import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

const CommonLoader: FC = (): JSX.Element => (
  <Box
    sx={{
      height: '80vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CircularProgress size={100} thickness={2} />
  </Box>
);

export default CommonLoader;
